import type { Optional } from '@festina-life/core'

import type { MetaModel } from '../types/metaModel'

export const getLayerMetaModelFromMap = ({
  layeredMetaModel,
  layerName,
}: {
  layeredMetaModel: Map<Optional<string>, MetaModel>
  layerName: Optional<string>
}): MetaModel => layeredMetaModel.get(layerName ?? null) ?? emptyMetaModel

export const emptyMetaModel = {
  types: new Map(),
}
